import Parent from "./parent";
import { observable, action} from 'mobx';

export default class Hopper extends Parent{
    @observable fillingStatus;
    constructor(num,capacity, name="Hopper", culture = 'None',  amount = 0, moisture = 0, waste = 0,amountState='',status='', scenario=[]){
        super(num, culture, scenario, amount, moisture, waste, status, name);
        this.totalCapacity = capacity;
        this.type = 'hopper'
        this.fillingStatus = false
    }


    @action filling(culture,delta,waste,moisture){
       super.filling(culture,delta,waste,moisture);
       this.fillingStatus = true
    }

    @action checkUnit(speed = 10){
        super.checkUnit(speed);
        this.fillingStatus = false;
    }
}


// WEBPACK FOOTER //
// ./src/shared/stores/objects/hopper.js